<template>
  <!-- 退单审核 -->
  <div class="retreatAudit">
    <!-- 面包屑导航 -->
    <crumbs-bar :crumbsList="['订单管理', $route.meta.title]">
      <template slot="controls">
        <!-- <el-button type="primary" icon="el-icon-download" @click="handleExport">导出退货单</el-button> -->
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">订单状态：</label>
        <el-select
          placeholder="订单状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入订单号/收货公司"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="username"
        show-overflow-tooltip
        label="申请人账号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="申请人姓名"
      >
      </el-table-column>
      <el-table-column
        prop="telphone"
        label="联系方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="businesscode"
        label="公司编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        label="公司名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="order_no"
        label="订单号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Source"
        label="下单渠道"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        label="下单时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="amount"
        label="退货时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="TypeStatus"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.TypeStatus == '-1'"
            >已拒绝</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.TypeStatus == '1'"
            >已同意</el-tag
          >
          <el-tag type="success" v-else>待审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.TypeStatus !== '0'"
            >已审核</el-tag
          >
          <el-button
            type="primary"
            v-else
            style="padding: 2px 3px"
            @click="lookGoodDetail(scope.row)"
            plain
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "retreatAudit",
  data() {
    return {
      /**表格数据 */
      //序号	申请人账号	申请人姓名	联系方式	公司编号	公司名称
      //	订单号	下单渠道	下单时间	退货时间	状态	操作
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      options: [
        {
          label: "全部",
          value: "9",
        },
        {
          label: "待审核",
          value: "0",
        },
        {
          label: "已通过",
          value: "1",
        },
        {
          label: "已反驳",
          value: "-1",
        },
      ],
      /**搜索表单 */
      searchForm: {
        status: "9",
        name: "",
      },
    };
  },
  components: {},
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Returngoods",
        status: this.searchForm.status,
        strwhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "proc_OrderQuery"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          console.log(res);
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    lookGoodDetail(row) {
      let parms = null;
      let parmser = {
        Id: row.Id,
        origin: row.origin,
        amount: row.amount,
      };
      parms = JSON.stringify(parmser);
      this.$router.push({
        path: "RetreatAuditDetail",
        query: {
          row: parms,
        },
      });
      parms = null;
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**点击导出 */
    handleExport() {
      let data = {
        type: "ReturnExport",
        status: this.searchForm.status,
        strwhere: this.searchForm.name,
      };
      let proc = "proc_OrderQuery"; //存储过程名
      window.location.href =
        this.baseUrl +
        "/API/Order/ExportExcelForOrderDetail?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=退货";
    },
  },
};
</script>

<style scoped>
.retreatAudit {
  width: 100%;
  height: 100%;
}
</style>
